import { isWhatsAppQuickReplyTemplateName } from 'cpool-utils';

import {
    WHATSAPP_TEMPLATE_PICKER_TABS,
    type WhatsAppTemplatePickerTab,
} from '~/features/whatsapp/constants/templatePicker';
import type { WhatsAppTemplate } from '~/features/whatsapp/hooks/useWhatsAppTemplates';

export const filterTemplatesForPickerTab = (
    templates: ReadonlyArray<WhatsAppTemplate>,
    tab: WhatsAppTemplatePickerTab,
): ReadonlyArray<WhatsAppTemplate> =>
    templates.filter((template) =>
        tab === WHATSAPP_TEMPLATE_PICKER_TABS.QUICK_REPLIES
            ? isWhatsAppQuickReplyTemplateName(template.templateName)
            : !isWhatsAppQuickReplyTemplateName(template.templateName),
    );
